import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import SumoDidiMedia from "./SumoDidiMedia";
import "./SumoDidiProject.css";

export default function SumoDidiProject({ film, stills = [] }) {
  const frames = stills.slice(0, 6);
  const archive = stills.slice(6);
  return (
    <article className="sumo-project">
      <div className="sumo-project__wrap">
        <Link to="/work" className="sumo-project__back"><ArrowLeft size={14} /> All work</Link>
        <header className="sumo-project__intro">
          <div className="sumo-project__title-row">
            <div>
              <h1>{film.title}</h1>
              <p className="sumo-project__eyebrow sumo-project__byline">A film by Jayant Krishna Rohatgi</p>
            </div>
            <p>{[film.category, "Hindi", film.year].filter(Boolean).join(" · ")}</p>
          </div>
        </header>

        <section className="sumo-project__hero" aria-label="Film poster and story">
          <div className="sumo-project__poster">
            <img src="/sumo-didi-official-poster.webp" width="1600" height="2000" alt="Sumo Didi official poster: Shriyam Bhagnani faces a sumo opponent" fetchPriority="high" />
          </div>
          <div className="sumo-project__story">
            <p className="sumo-project__eyebrow">The story</p>
            <p className="sumo-project__logline">{film.logline}</p>
            <div className="sumo-project__release">
              <span className="sumo-project__eyebrow">Festival Accolades</span>
            </div>
            <div className="sumo-project__hero-festivals">
              {(film.festivals || []).map((festival) => (
                <div key={festival.name}>
                  <p>{festival.name}</p><span>{festival.note}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="sumo-film-videos" className="sumo-project__section">
          <div className="sumo-project__section-heading"><p className="sumo-project__eyebrow">Watch</p><h2>A first look.</h2></div>
          <SumoDidiMedia layout="grid" showLinks />
        </section>

        {film.directorsNote && (
          <section className="sumo-project__note sumo-project__section">
            <div><p className="sumo-project__eyebrow">Behind the film</p><h2>Director’s note.</h2></div>
            <p>{film.directorsNote}</p>
          </section>
        )}

        {frames.length > 0 && (
          <section className="sumo-project__section">
            <div className="sumo-project__section-heading"><p className="sumo-project__eyebrow">Selected stills</p><h2>Inside the frame.</h2></div>
            <div className="sumo-project__frames">{frames.map((src, i) => (
              <figure key={src + i}><img src={src} alt={`${film.title} film still ${i + 1}`} loading="lazy" /><figcaption>{String(i + 1).padStart(2, "0")}</figcaption></figure>
            ))}</div>
          </section>
        )}

        {film.credits && (
          <section className="sumo-project__section">
            <div className="sumo-project__section-heading"><p className="sumo-project__eyebrow">The people</p><h2>Film credits.</h2></div>
            <dl className="sumo-project__credits">{Object.entries(film.credits).map(([key, value]) => (
              <div key={key}><dt>{key.replace(/([A-Z])/g, " $1").trim()}</dt><dd>{value}</dd></div>
            ))}</dl>
          </section>
        )}

        {archive.length > 0 && (
          <section className="sumo-project__section">
            <div className="sumo-project__section-heading"><p className="sumo-project__eyebrow">Festival journey</p><h2>From the archive.</h2></div>
            <div className="sumo-project__archive">{archive.map((src, i) => <img key={src + i} src={src} alt={`${film.title} festival poster ${i + 1}`} loading="lazy" />)}</div>
          </section>
        )}
        <nav className="sumo-project__end" aria-label="More about the film">
          {film.externalLink && <a href={film.externalLink} target="_blank" rel="noopener noreferrer">Read the press coverage <ArrowUpRight size={16} /></a>}
          <Link to="/work">Explore all work <ArrowUpRight size={16} /></Link>
        </nav>
      </div>
    </article>
  );
}
